'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _slicedToArray = require('@babel/runtime-corejs3/helpers/slicedToArray');
var _includesInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/includes');
var _sliceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/slice');
var _mapInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/map');
var _parseInt = require('@babel/runtime-corejs3/core-js-stable/parse-int');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _includesInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_includesInstanceProperty);
var _sliceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_sliceInstanceProperty);
var _mapInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_mapInstanceProperty);
var _parseInt__default = /*#__PURE__*/_interopDefaultLegacy(_parseInt);

var reservedWords = [
// _
'_internal_attr_tag',
// a
'accum', 'add', 'admin', 'all', 'allocate', 'alter', 'and', 'any', 'as', 'asc', 'avg',
// b
'bag', 'batch', 'between', 'bigint', 'blob', 'bool', 'boolean', 'both', 'break', 'by',
// c
'call', 'cascade', 'case', 'catch', 'char', 'character', 'check', 'clob', 'coalesce', 'compress', 'const', 'constraint', 'continue', 'cost', 'count', 'create', 'current_date', 'current_time', 'current_timestamp', 'cursor',
// d
'datetime', 'datetime_add', 'datetime_sub', 'decimal', 'declare', 'delete', 'desc', 'discriminator', 'distributed', 'do', 'double', 'drop',
// e
'edge', 'else', 'elseif', 'end', 'escape', 'exception', 'exists',
// f
'false', 'file', 'filter', 'fixed_binary', 'float', 'for', 'foreach', 'from', 'function',
// g
'global', 'grants', 'graph', 'group', 'groupbyaccum', 'gsql_sys_tag',
// h
'having', 'header', 'heapaccum',
// i
'if', 'ignore', 'in', 'index', 'input_line_filter', 'insert', 'int', 'int16', 'int32', 'int32_t', 'int64_t', 'int8', 'integer', 'interpret', 'intersect', 'into', 'is', 'isempty',
// j
'job', 'join', 'jsonarray', 'jsonobject',
// k
'kafka', 'key',
// l
'leading', 'like', 'limit', 'list', 'load', 'loadaccum', 'log', 'long',
// m
'map', 'max', 'min', 'minus',
// n
'nobody', 'not', 'now', 'null',
// o
'offset', 'on', 'opencypher', 'or', 'order',
// p
'package', 'pinned', 'post-accum', 'post_accum', 'primary', 'primary_id', 'print', 'proxy',
// q
'query', 'quit',
// r
'raise', 'range', 'reduce', 'replace', 'reset_collection_accum', 'return', 'returns', 'run',
// s
's3', 'sample', 'select', 'selectvertex', 'set', 'static', 'string', 'sum', 'sys.filename', 'sys.internal_id',
// t
'target', 'temp_table', 'then', 'to', 'to_csv', 'to_datetime', 'trailing', 'translatesql', 'trim', 'true', 'try', 'tuple', 'typedef',
// u
'uint', 'uint16', 'uint32', 'uint32_t', 'uint64_t', 'uint8', 'uint8_t', 'union', 'update', 'upsert', 'using',
// v
'values', 'vertex',
// w
'when', 'where', 'while', 'with'];
var reservedWordCaseSensitive = [];
var nonReservedWords = [];
var uIntegerRegex = '^[0-9]+$';
var integerRegex = '^-?[0-9]+$';
var nameRegex = '^[a-zA-Z_]([a-zA-Z0-9_])*$';
var realRegex = '^-?([0-9]+([.][0-9]*)?|[0-9]*[.][0-9]+)$';
var boolRegex = '^([tT][rR][uU][eE]|[fF][aA][lL][sS][eE]|0|1)$';
var datetimeRegex = ['^[0-9]{4}-[0-9]{2}-[0-9]{2}$',
// %Y-%m-%d
'^[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2}$',
// %Y-%m-%d %H:%M:%S
'^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}\.[0-9]{3}z$',
// %Y-%m-%dT%H:%M:%S.000z
'^[0-9]{4}/[0-9]{2}/[0-9]{2}$',
// %Y/%m/%d
'^[0-9]{4}/[0-9]{2}/[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2}$',
// %Y/%m/%d %H:%M:%S，
'^[0-9]*$' // timestamp
];
var DatetimeFormat = /*#__PURE__*/function (DatetimeFormat) {
  DatetimeFormat[DatetimeFormat["DashDay"] = 0] = "DashDay";
  DatetimeFormat[DatetimeFormat["DashSecond"] = 1] = "DashSecond";
  DatetimeFormat[DatetimeFormat["DashMillisecond"] = 2] = "DashMillisecond";
  DatetimeFormat[DatetimeFormat["SlashDay"] = 3] = "SlashDay";
  DatetimeFormat[DatetimeFormat["SlashSecond"] = 4] = "SlashSecond";
  DatetimeFormat[DatetimeFormat["Timestamp"] = 5] = "Timestamp";
  return DatetimeFormat;
}({});
exports.FormatValidator = void 0;
(function (_FormatValidator) {
  function isName(val) {
    if (val && !_includesInstanceProperty__default["default"](nonReservedWords).call(nonReservedWords, val.toLowerCase())) {
      if (_includesInstanceProperty__default["default"](reservedWords).call(reservedWords, val.toLowerCase()) || _includesInstanceProperty__default["default"](reservedWordCaseSensitive).call(reservedWordCaseSensitive, val)) {
        return {
          success: false,
          message: "\"".concat(val, "\" is a reserved word.")
        };
      }
    }
    return test(val, new RegExp(nameRegex), 'Valid name starts with a letter, followed by letters or digits.');
  }
  _FormatValidator.isName = isName;
  function isAccum(val) {
    var toCheck = val && val[0] === '@' ? _sliceInstanceProperty__default["default"](val).call(val, 1) : val;
    return test(toCheck, new RegExp(nameRegex), 'Valid name starts with a letter, followed by letters or digits.');
  }
  _FormatValidator.isAccum = isAccum;
  function isUInt(val) {
    var regExp = new RegExp(uIntegerRegex);
    return test(val, regExp, 'Should be non-negative integer.');
  }
  _FormatValidator.isUInt = isUInt;
  function isInt(val) {
    var regExp = new RegExp(integerRegex);
    return test(val, regExp, 'Should be integer.');
  }
  _FormatValidator.isInt = isInt;
  function isReal(val) {
    var regExp = new RegExp(realRegex);
    return test(val, regExp, 'Should be real number.');
  }
  _FormatValidator.isReal = isReal;
  function isBoolean(val) {
    var regExp = new RegExp(boolRegex);
    return test(val, regExp, 'Should be "true" or "false".');
  }
  _FormatValidator.isBoolean = isBoolean;
  function isDatetime(val) {
    var _context, _context2, _context3, _context4, _context5, _context6, _context7, _context8;
    var required = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var i = 0;
    var regExp;
    var year;
    var month;
    var day;
    var hour;
    var minute;
    var second;
    var yearMonthDay;
    var hourMinuteSecond;
    if (required || !required && val !== '') {
      // Check the string must be number format, and must be a valid datetime
      for (; i < datetimeRegex.length; i++) {
        regExp = new RegExp(datetimeRegex[i]);
        if (regExp.test(val)) {
          break;
        }
      }
      switch (i) {
        case DatetimeFormat.DashDay:
          var _val$split$map = _mapInstanceProperty__default["default"](_context = val.split('-')).call(_context, function (value) {
            return _parseInt__default["default"](value, 10);
          });
          var _val$split$map2 = _slicedToArray__default["default"](_val$split$map, 3);
          year = _val$split$map2[0];
          month = _val$split$map2[1];
          day = _val$split$map2[2];
          break;
        case DatetimeFormat.DashSecond:
          var _val$split = val.split(' ');
          var _val$split2 = _slicedToArray__default["default"](_val$split, 2);
          yearMonthDay = _val$split2[0];
          hourMinuteSecond = _val$split2[1];
          var _yearMonthDay$split$m = _mapInstanceProperty__default["default"](_context2 = yearMonthDay.split('-')).call(_context2, function (value) {
            return _parseInt__default["default"](value, 10);
          });
          var _yearMonthDay$split$m2 = _slicedToArray__default["default"](_yearMonthDay$split$m, 3);
          year = _yearMonthDay$split$m2[0];
          month = _yearMonthDay$split$m2[1];
          day = _yearMonthDay$split$m2[2];
          var _hourMinuteSecond$spl = _mapInstanceProperty__default["default"](_context3 = hourMinuteSecond.split(':')).call(_context3, function (value) {
            return _parseInt__default["default"](value, 10);
          });
          var _hourMinuteSecond$spl2 = _slicedToArray__default["default"](_hourMinuteSecond$spl, 3);
          hour = _hourMinuteSecond$spl2[0];
          minute = _hourMinuteSecond$spl2[1];
          second = _hourMinuteSecond$spl2[2];
          break;
        case DatetimeFormat.DashMillisecond:
          var _val$split$0$split = val.split('.')[0].split('T');
          var _val$split$0$split2 = _slicedToArray__default["default"](_val$split$0$split, 2);
          yearMonthDay = _val$split$0$split2[0];
          hourMinuteSecond = _val$split$0$split2[1];
          var _yearMonthDay$split$m3 = _mapInstanceProperty__default["default"](_context4 = yearMonthDay.split('-')).call(_context4, function (value) {
            return _parseInt__default["default"](value, 10);
          });
          var _yearMonthDay$split$m4 = _slicedToArray__default["default"](_yearMonthDay$split$m3, 3);
          year = _yearMonthDay$split$m4[0];
          month = _yearMonthDay$split$m4[1];
          day = _yearMonthDay$split$m4[2];
          var _hourMinuteSecond$spl3 = _mapInstanceProperty__default["default"](_context5 = hourMinuteSecond.split(':')).call(_context5, function (value) {
            return _parseInt__default["default"](value, 10);
          });
          var _hourMinuteSecond$spl4 = _slicedToArray__default["default"](_hourMinuteSecond$spl3, 3);
          hour = _hourMinuteSecond$spl4[0];
          minute = _hourMinuteSecond$spl4[1];
          second = _hourMinuteSecond$spl4[2];
          break;
        case DatetimeFormat.SlashDay:
          var _val$split$map3 = _mapInstanceProperty__default["default"](_context6 = val.split('/')).call(_context6, function (value) {
            return _parseInt__default["default"](value, 10);
          });
          var _val$split$map4 = _slicedToArray__default["default"](_val$split$map3, 3);
          year = _val$split$map4[0];
          month = _val$split$map4[1];
          day = _val$split$map4[2];
          break;
        case DatetimeFormat.SlashSecond:
          var _val$split3 = val.split(' ');
          var _val$split4 = _slicedToArray__default["default"](_val$split3, 2);
          yearMonthDay = _val$split4[0];
          hourMinuteSecond = _val$split4[1];
          var _yearMonthDay$split$m5 = _mapInstanceProperty__default["default"](_context7 = yearMonthDay.split('/')).call(_context7, function (value) {
            return _parseInt__default["default"](value, 10);
          });
          var _yearMonthDay$split$m6 = _slicedToArray__default["default"](_yearMonthDay$split$m5, 3);
          year = _yearMonthDay$split$m6[0];
          month = _yearMonthDay$split$m6[1];
          day = _yearMonthDay$split$m6[2];
          var _hourMinuteSecond$spl5 = _mapInstanceProperty__default["default"](_context8 = hourMinuteSecond.split(':')).call(_context8, function (value) {
            return _parseInt__default["default"](value, 10);
          });
          var _hourMinuteSecond$spl6 = _slicedToArray__default["default"](_hourMinuteSecond$spl5, 3);
          hour = _hourMinuteSecond$spl6[0];
          minute = _hourMinuteSecond$spl6[1];
          second = _hourMinuteSecond$spl6[2];
          break;
        case DatetimeFormat.Timestamp:
          var datetime = new Date(_parseInt__default["default"](val, 10) * 1000);
          year = datetime.getFullYear();
          month = datetime.getMonth() + 1;
          day = datetime.getDate();
          hour = datetime.getHours();
          minute = datetime.getMinutes();
          second = datetime.getSeconds();
          break;
        default:
          return {
            success: false,
            message: 'Invalid datetime. Valid format: yyyy-MM-dd or yyyy-MM-dd hh:mm:ss.' + 'For more formats, please refer to the documentation.'
          };
      }
    }

    // Month between 1 and 12.
    if (month < 1 || month > 12) {
      return {
        success: false,
        message: 'Invalid datetime. Month should be between 1 and 12.'
      };
    }
    // Day depends on month.
    var dayUpperLimit = 31;
    switch (month) {
      case 4:
      case 6:
      case 9:
      case 11:
        {
          dayUpperLimit = 30;
          break;
        }
      case 2:
        {
          dayUpperLimit = !(year % 400) || !(year % 4) && year % 100 ? 29 : 28;
        }
    }
    if (day < 1 || day > dayUpperLimit) {
      return {
        success: false,
        message: "Invalid datetime. Day should be between 1 and ".concat(dayUpperLimit, ".")
      };
    }
    if (hourMinuteSecond) {
      if (hour < 0 || hour > 23) {
        return {
          success: false,
          message: "Invalid datetime. Hour should be between 0 and 23."
        };
      }
      if (minute < 0 || minute > 59) {
        return {
          success: false,
          message: "Invalid datetime. Minute should be between 0 and 59."
        };
      }
      if (second < 0 || second > 59) {
        return {
          success: false,
          message: "Invalid datetime. Second should be between 0 and 59."
        };
      }
    }
    return {
      success: true,
      message: ''
    };
  }
  _FormatValidator.isDatetime = isDatetime;
  function getDateTimeFormat(date) {
    var i = 0;
    var regExp;
    for (; i < datetimeRegex.length; i++) {
      regExp = new RegExp(datetimeRegex[i]);
      if (regExp.test(date)) {
        break;
      }
    }
    return i;
  }
  _FormatValidator.getDateTimeFormat = getDateTimeFormat;
  /**
   * Test whether the input string follows corresponding format or not.
   *
   * @param {string} val
   * @param {RegExp} regExp
   * @param {string} msg
   * @returns {ValidateResult}
   */
  function test(val, regExp, msg) {
    if (val === undefined) {
      return {
        success: false,
        message: 'Empty string.'
      };
    }
    if (val && regExp.test(val)) {
      return {
        success: true,
        message: ''
      };
    } else {
      return {
        success: false,
        message: msg
      };
    }
  }
})(exports.FormatValidator || (exports.FormatValidator = {}));

exports.DatetimeFormat = DatetimeFormat;
exports.boolRegex = boolRegex;
exports.datetimeRegex = datetimeRegex;
exports.integerRegex = integerRegex;
exports.nameRegex = nameRegex;
exports.nonReservedWords = nonReservedWords;
exports.realRegex = realRegex;
exports.reservedWordCaseSensitive = reservedWordCaseSensitive;
exports.reservedWords = reservedWords;
exports.uIntegerRegex = uIntegerRegex;
